import { Overview } from '#src/pages/seo/club/Overview/index.tsx';

import { useLayoutData } from './layout.tsx';

const FootballClub = () => {
  const club = useLayoutData();
  const seasonStartYear = club.domesticLeague?.seasons.slice(-1)[0]?.startYear;

  return <Overview seasonStartYear={seasonStartYear} />;
};

export default FootballClub;
